import React from 'react';

export default props => {
        return (
            <h3>Notes</h3>
        )
}